import { useEffect } from 'react';
import { screenLog } from '../lib/logging';

/**
 * Logs the screen name on mount.
 */
export const usePageTracking = (pageName: string): void => {
    useEffect(() => {
        screenLog(pageName);
    }, []);
};
